
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import Home from "./Views/Home/Home";
import { ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import CompanyProducts from "./Views/company-products/CompanyProducts";
import NavBar from "./Components/common/NavBar/NavBar";
import Footer from "./Components/common/Footer";
import Blogs from "./Views/Blogs/Blogs";
import BlogPost from "./Views/Blogs/BlogPost";
import ProductVariants from "./Views/company-products/ProductVariants";
import VariantDetail from "./Views/company-products/VarientDetail";
import AutoScrollTop from "./Components/AutoScrollTop";
import AllLatestProducts from "./Views/LatestProducts/AllLatestProducts";
import LatestProductDetail from "./Views/LatestProducts/LatestProductDetail";
import AboutUs from "./Views/aboutus";
import ContactUs from "./Views/contactus";
import EProductList from "./Views/Electronics/ProductList";
import EProductDetail from "./Views/Electronics/EProductDetail";
import SProductList from "./Views/Solar/SProductList";
import SProductDetail from "./Views/Solar/SProductDetail";
import BikeListing from "./Views/Bike/BikeListing";
import BikeDetailVariants from "./Views/Bike/BikeDetailVariants";
import BikeVariantDetail from "./Views/Bike/BikeVarientDeta";
import AllVideos from "./Views/AllVideos";
import OurServices from "./Views/OurServices";
import ServicesDetail from "./Views/ServicesDetail";
import Ebikes from "./Views/CompanyList/Ebikes";
import Solar from "./Views/CompanyList/Solar";
import AddShop from "./Views/Shops/AddShop";
import ShopLists from "./Views/Shops/ShopLists";
import ShopDetail from "./Views/Shops/ShopDetail";
import ComparePRoduct from "./Views/Compare/compare";
import FaqsPage from "./Views/FaqsPage";
import ServicesOnlyDetail from "./Views/ServiceOnlyDetail";
// Dashboard

import LoginPage from "./Dashboard/login";
import DashboardLayout from "./Dashboard/DashboardLayout";
import Register from "./Dashboard/RegisterUSer";
import ProtectedRoute from "./Dashboard/ProtectedRoute";
import Dashboard from "./Dashboard/Dashboard";
import CreatAd from "./Dashboard/CreateAd";
import EditAd from "./Dashboard/EditAd";
import AllAd from "./Views/Ad/AllAd";
import AdDetail from "./Views/Ad/AdDetail";
import AllProducts from "./Views/EnergyBazzarStore/AllProducts";
import BazzarProductDetail from "./Views/EnergyBazzarStore/BazzarProductDetail";
function Layout({ children }) {
  const location = useLocation();

  // hide header/footer on login & dashboard
  // const hideHeaderFooter =
  //   location.pathname.startsWith("/login") || location.pathname.startsWith("/register") ||
  //   location.pathname.startsWith("/dashboard");

  return (
    <>
     <NavBar />
      <AutoScrollTop />
      {children}
      <Footer />
    </>
  );
}
function App() {
  return (
    <>
      <ToastContainer limit={1} />
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/:id/:id" element={<CompanyProducts />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:id" element={<BlogPost />} />
            <Route path="/:id/:id/:id" element={<ProductVariants />} />
            <Route path="/:id/:id/:id/:id" element={<VariantDetail />} />
            <Route path="/latest-products/:id" element={<AllLatestProducts />} />
            <Route path="/latest-product-detail/:id" element={<LatestProductDetail />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/electronics/:id" element={<EProductList />} />
            <Route path="/electronics/:id/:id" element={<EProductDetail />} />
            <Route path="/solar/:id" element={<SProductList />} />
            <Route path="/solar/:id/:id" element={<SProductDetail />} />
            <Route path="/e-bikes/:id" element={<BikeListing />} />
            <Route path="/e-bikes/:id/:id" element={<BikeDetailVariants />} />
            <Route path="e-bikes/:id/:id/:id" element={<BikeVariantDetail />} />
            <Route path="/e-bikes" element={<Ebikes />} />
            <Route path="/:id" element={<Solar />} />
            <Route path="/products" element={<AllProducts />} />
            <Route path="/products/:id" element={<BazzarProductDetail />} />

            <Route path="/all-videos" element={<AllVideos />} />
            <Route path="/our-services" element={<OurServices />} />
            <Route path="/service-detail/:id" element={<ServicesDetail />} />

            <Route path="/add-shop" element={<AddShop />} />
            <Route path="/our-services/find-service-providers" element={<ShopLists />} />
            <Route path="/our-services/find-service-providers/:id" element={<ShopDetail />} />
            <Route path="/our-services/:id" element={<ServicesOnlyDetail />} />
            <Route path="/comparison" element={<ComparePRoduct />} />
            <Route path="/faqs" element={<FaqsPage />} />

            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<Register />} />
            <Route path="/ad" element={<AllAd />} />
            <Route path="/ad/:id" element={<AdDetail />} />
            <Route path="/dashboard/*" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="create-ad" element={<CreatAd />} />
              <Route path="edit-ad/:id" element={<EditAd />} />
              
            </Route>
          </Routes>
        </Layout>
      </Router>
    </>
  );
}

export default App;
